/**
 * @generated SignedSource<<539fb256ce69b2b8c23bb34abca969bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssignmentDueAtStatus = "DUE_SOON" | "NONE" | "OVERDUE" | "%future added value";
export type AssignmentStatus = "ACCEPTED" | "CANCELED" | "IN_PROGRESS" | "NONE" | "NOT_STARTED" | "READY_FOR_REVIEW" | "REJECTED" | "UNDER_REVIEW" | "%future added value";
export type FeedbackLevel = "CRITICAL" | "MAJOR" | "MINOR" | "SUGGESTION" | "%future added value";
export type FlowType = "BLUEPRINT" | "NONE" | "%future added value";
export type LinkedType = "MODULE" | "MODULE_GROUP" | "TASK" | "TEMPLATE" | "UNKNOWN" | "%future added value";
export type PolFileUploadStatus = "ERROR" | "NOT_STARTED" | "SCANNING" | "SUCCESS" | "WAITING_FOR_JOB" | "%future added value";
export type ProgramType = "ACCESSORIES_3_D_ACCREDITATION" | "A_A_3_D_ACCREDITATION" | "NONE" | "SOFT_HOME_3_D_ACCREDITATION" | "_3_D_STYLING" | "%future added value";
export type SoftwareType = "BROWZWEAR" | "CLO" | "NONE" | "OPTITEX" | "%future added value";
export type SubmissionStatus = "ACCEPTED" | "READY_FOR_REVIEW" | "REJECTED" | "%future added value";
export type UserStatus = "ACTIVE" | "DEACTIVATED" | "SUSPENDED" | "%future added value";
export type UserType = "ADMIN" | "BLOCKED" | "EXTERNAL_USER" | "INTERNAL_USER" | "REVIEWER" | "%future added value";
export type WorkflowType = "ACCREDITATION" | "%future added value";
export type FlowFilter = {
  activities?: FlowToManyActivityFilter | null | undefined;
  activitiesExist?: boolean | null | undefined;
  adminDashboardFlowComments?: FlowToManyAdminDashboardFlowCommentFilter | null | undefined;
  adminDashboardFlowCommentsExist?: boolean | null | undefined;
  and?: ReadonlyArray<FlowFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  assignedAt?: DatetimeFilter | null | undefined;
  assignedBy?: GwtUserFilter | null | undefined;
  assignedByExists?: boolean | null | undefined;
  assignedById?: UUIDFilter | null | undefined;
  assignedTo?: GwtUserFilter | null | undefined;
  assignedToExists?: boolean | null | undefined;
  assignedToId?: UUIDFilter | null | undefined;
  assignmentDueAtStatus?: AssignmentDueAtStatusFilter | null | undefined;
  assignmentStatus?: AssignmentStatusFilter | null | undefined;
  completedAt?: DatetimeFilter | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  description?: StringFilter | null | undefined;
  dueAt?: DatetimeFilter | null | undefined;
  durationInSeconds?: IntFilter | null | undefined;
  durationSeconds?: IntFilter | null | undefined;
  flowComments?: FlowToManyFlowCommentFilter | null | undefined;
  flowCommentsExist?: boolean | null | undefined;
  flowFavorites?: FlowToManyFlowFavoriteFilter | null | undefined;
  flowFavoritesExist?: boolean | null | undefined;
  flowReviewers?: FlowToManyFlowReviewerFilter | null | undefined;
  flowReviewersExist?: boolean | null | undefined;
  flowType?: FlowTypeFilter | null | undefined;
  lastModifiedBy?: GwtUserFilter | null | undefined;
  lastModifiedByExists?: boolean | null | undefined;
  lastModifiedById?: UUIDFilter | null | undefined;
  linkedType?: LinkedTypeFilter | null | undefined;
  module?: ModuleFilter | null | undefined;
  moduleExists?: boolean | null | undefined;
  moduleGroup?: ModuleGroupFilter | null | undefined;
  moduleGroupExists?: boolean | null | undefined;
  name?: StringFilter | null | undefined;
  not?: FlowFilter | null | undefined;
  or?: ReadonlyArray<FlowFilter> | null | undefined;
  owner?: GwtUserFilter | null | undefined;
  ownerId?: UUIDFilter | null | undefined;
  reviewerDashboardFlowComments?: FlowToManyReviewerDashboardFlowCommentFilter | null | undefined;
  reviewerDashboardFlowCommentsExist?: boolean | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  startedAt?: DatetimeFilter | null | undefined;
  statusChangedAt?: DatetimeFilter | null | undefined;
  task?: TaskFilter | null | undefined;
  taskExists?: boolean | null | undefined;
  template?: TemplateFilter | null | undefined;
  templateExists?: boolean | null | undefined;
  updatedAt?: DatetimeFilter | null | undefined;
  workflowType?: WorkflowTypeFilter | null | undefined;
};
export type UUIDFilter = {
  equalTo?: UUID | null | undefined;
  greaterThan?: UUID | null | undefined;
  greaterThanOrEqualTo?: UUID | null | undefined;
  in?: ReadonlyArray<UUID> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: UUID | null | undefined;
  lessThanOrEqualTo?: UUID | null | undefined;
  notEqualTo?: UUID | null | undefined;
  notIn?: ReadonlyArray<UUID> | null | undefined;
};
export type AssignmentStatusFilter = {
  equalTo?: AssignmentStatus | null | undefined;
  greaterThan?: AssignmentStatus | null | undefined;
  greaterThanOrEqualTo?: AssignmentStatus | null | undefined;
  in?: ReadonlyArray<AssignmentStatus> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: AssignmentStatus | null | undefined;
  lessThanOrEqualTo?: AssignmentStatus | null | undefined;
  notEqualTo?: AssignmentStatus | null | undefined;
  notIn?: ReadonlyArray<AssignmentStatus> | null | undefined;
};
export type DatetimeFilter = {
  equalTo?: Date | null | undefined;
  greaterThan?: Date | null | undefined;
  greaterThanOrEqualTo?: Date | null | undefined;
  in?: ReadonlyArray<Date> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: Date | null | undefined;
  lessThanOrEqualTo?: Date | null | undefined;
  notEqualTo?: Date | null | undefined;
  notIn?: ReadonlyArray<Date> | null | undefined;
};
export type FlowTypeFilter = {
  equalTo?: FlowType | null | undefined;
  greaterThan?: FlowType | null | undefined;
  greaterThanOrEqualTo?: FlowType | null | undefined;
  in?: ReadonlyArray<FlowType> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: FlowType | null | undefined;
  lessThanOrEqualTo?: FlowType | null | undefined;
  notEqualTo?: FlowType | null | undefined;
  notIn?: ReadonlyArray<FlowType> | null | undefined;
};
export type LinkedTypeFilter = {
  equalTo?: LinkedType | null | undefined;
  greaterThan?: LinkedType | null | undefined;
  greaterThanOrEqualTo?: LinkedType | null | undefined;
  in?: ReadonlyArray<LinkedType> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: LinkedType | null | undefined;
  lessThanOrEqualTo?: LinkedType | null | undefined;
  notEqualTo?: LinkedType | null | undefined;
  notIn?: ReadonlyArray<LinkedType> | null | undefined;
};
export type WorkflowTypeFilter = {
  equalTo?: WorkflowType | null | undefined;
  greaterThan?: WorkflowType | null | undefined;
  greaterThanOrEqualTo?: WorkflowType | null | undefined;
  in?: ReadonlyArray<WorkflowType> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: WorkflowType | null | undefined;
  lessThanOrEqualTo?: WorkflowType | null | undefined;
  notEqualTo?: WorkflowType | null | undefined;
  notIn?: ReadonlyArray<WorkflowType> | null | undefined;
};
export type StringFilter = {
  equalTo?: string | null | undefined;
  greaterThan?: string | null | undefined;
  greaterThanOrEqualTo?: string | null | undefined;
  in?: ReadonlyArray<string> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: string | null | undefined;
  lessThanOrEqualTo?: string | null | undefined;
  likeInsensitive?: string | null | undefined;
  notEqualTo?: string | null | undefined;
  notIn?: ReadonlyArray<string> | null | undefined;
};
export type AssignmentDueAtStatusFilter = {
  equalTo?: AssignmentDueAtStatus | null | undefined;
  greaterThan?: AssignmentDueAtStatus | null | undefined;
  greaterThanOrEqualTo?: AssignmentDueAtStatus | null | undefined;
  in?: ReadonlyArray<AssignmentDueAtStatus> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: AssignmentDueAtStatus | null | undefined;
  lessThanOrEqualTo?: AssignmentDueAtStatus | null | undefined;
  notEqualTo?: AssignmentDueAtStatus | null | undefined;
  notIn?: ReadonlyArray<AssignmentDueAtStatus> | null | undefined;
};
export type IntFilter = {
  equalTo?: number | null | undefined;
  greaterThan?: number | null | undefined;
  greaterThanOrEqualTo?: number | null | undefined;
  in?: ReadonlyArray<number> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: number | null | undefined;
  lessThanOrEqualTo?: number | null | undefined;
  notEqualTo?: number | null | undefined;
  notIn?: ReadonlyArray<number> | null | undefined;
};
export type FlowToManyActivityFilter = {
  every?: ActivityFilter | null | undefined;
  none?: ActivityFilter | null | undefined;
  some?: ActivityFilter | null | undefined;
};
export type ActivityFilter = {
  and?: ReadonlyArray<ActivityFilter> | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowExists?: boolean | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  gwtUser?: GwtUserFilter | null | undefined;
  gwtUserId?: UUIDFilter | null | undefined;
  linkLocation?: StringFilter | null | undefined;
  not?: ActivityFilter | null | undefined;
  object?: StringFilter | null | undefined;
  or?: ReadonlyArray<ActivityFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  verb?: StringFilter | null | undefined;
  workflowType?: WorkflowTypeFilter | null | undefined;
};
export type GwtUserFilter = {
  activities?: GwtUserToManyActivityFilter | null | undefined;
  activitiesExist?: boolean | null | undefined;
  allCertifications?: StringListFilter | null | undefined;
  and?: ReadonlyArray<GwtUserFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  commentVieweds?: GwtUserToManyCommentViewedFilter | null | undefined;
  commentViewedsExist?: boolean | null | undefined;
  comments?: GwtUserToManyCommentFilter | null | undefined;
  commentsExist?: boolean | null | undefined;
  companiesByOwnerId?: GwtUserToManyCompanyFilter | null | undefined;
  companiesByOwnerIdExist?: boolean | null | undefined;
  company?: CompanyFilter | null | undefined;
  companyExists?: boolean | null | undefined;
  companyId?: UUIDFilter | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  email?: StringFilter | null | undefined;
  emailBulk?: BooleanFilter | null | undefined;
  emailBulkTime?: DatetimeFilter | null | undefined;
  emailModuleNotifications?: StringListFilter | null | undefined;
  emailOnAllAssignmentStatusChanges?: BooleanFilter | null | undefined;
  emailOnCommentAdded?: BooleanFilter | null | undefined;
  emailOnFeedbackProvided?: BooleanFilter | null | undefined;
  feedbacks?: GwtUserToManyFeedbackFilter | null | undefined;
  feedbacksByClaimedById?: GwtUserToManyFeedbackFilter | null | undefined;
  feedbacksByClaimedByIdExist?: boolean | null | undefined;
  feedbacksExist?: boolean | null | undefined;
  firstName?: StringFilter | null | undefined;
  flowFavorites?: GwtUserToManyFlowFavoriteFilter | null | undefined;
  flowFavoritesExist?: boolean | null | undefined;
  flowsByAssignedById?: GwtUserToManyFlowFilter | null | undefined;
  flowsByAssignedByIdExist?: boolean | null | undefined;
  flowsByAssignedToId?: GwtUserToManyFlowFilter | null | undefined;
  flowsByAssignedToIdExist?: boolean | null | undefined;
  flowsByLastModifiedById?: GwtUserToManyFlowFilter | null | undefined;
  flowsByLastModifiedByIdExist?: boolean | null | undefined;
  flowsByOwnerId?: GwtUserToManyFlowFilter | null | undefined;
  flowsByOwnerIdExist?: boolean | null | undefined;
  fullName?: StringFilter | null | undefined;
  isSystemUser?: BooleanFilter | null | undefined;
  jobTitle?: StringFilter | null | undefined;
  lanId?: StringFilter | null | undefined;
  lastName?: StringFilter | null | undefined;
  moduleSubmissionsByAcceptedById?: GwtUserToManyModuleSubmissionFilter | null | undefined;
  moduleSubmissionsByAcceptedByIdExist?: boolean | null | undefined;
  not?: GwtUserFilter | null | undefined;
  notifications?: GwtUserToManyNotificationFilter | null | undefined;
  notificationsExist?: boolean | null | undefined;
  or?: ReadonlyArray<GwtUserFilter> | null | undefined;
  partnersonline?: BooleanFilter | null | undefined;
  polFileUploads?: GwtUserToManyPolFileUploadFilter | null | undefined;
  polFileUploadsExist?: boolean | null | undefined;
  programs?: ProgramTypeListFilter | null | undefined;
  pronouns?: StringFilter | null | undefined;
  reviewedFlowReviewers?: GwtUserToManyFlowReviewerFilter | null | undefined;
  reviewedFlowReviewersExist?: boolean | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  status?: UserStatusFilter | null | undefined;
  updatedAt?: DatetimeFilter | null | undefined;
  userPriority?: IntFilter | null | undefined;
  userType?: UserTypeFilter | null | undefined;
};
export type UserTypeFilter = {
  equalTo?: UserType | null | undefined;
  greaterThan?: UserType | null | undefined;
  greaterThanOrEqualTo?: UserType | null | undefined;
  in?: ReadonlyArray<UserType> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: UserType | null | undefined;
  lessThanOrEqualTo?: UserType | null | undefined;
  notEqualTo?: UserType | null | undefined;
  notIn?: ReadonlyArray<UserType> | null | undefined;
};
export type BooleanFilter = {
  equalTo?: boolean | null | undefined;
  greaterThan?: boolean | null | undefined;
  greaterThanOrEqualTo?: boolean | null | undefined;
  in?: ReadonlyArray<boolean> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: boolean | null | undefined;
  lessThanOrEqualTo?: boolean | null | undefined;
  notEqualTo?: boolean | null | undefined;
  notIn?: ReadonlyArray<boolean> | null | undefined;
};
export type StringListFilter = {
  equalTo?: ReadonlyArray<string | null | undefined> | null | undefined;
  greaterThan?: ReadonlyArray<string | null | undefined> | null | undefined;
  greaterThanOrEqualTo?: ReadonlyArray<string | null | undefined> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: ReadonlyArray<string | null | undefined> | null | undefined;
  lessThanOrEqualTo?: ReadonlyArray<string | null | undefined> | null | undefined;
  notEqualTo?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type UserStatusFilter = {
  equalTo?: UserStatus | null | undefined;
  greaterThan?: UserStatus | null | undefined;
  greaterThanOrEqualTo?: UserStatus | null | undefined;
  in?: ReadonlyArray<UserStatus> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: UserStatus | null | undefined;
  lessThanOrEqualTo?: UserStatus | null | undefined;
  notEqualTo?: UserStatus | null | undefined;
  notIn?: ReadonlyArray<UserStatus> | null | undefined;
};
export type ProgramTypeListFilter = {
  equalTo?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  greaterThan?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  greaterThanOrEqualTo?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  lessThanOrEqualTo?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
  notEqualTo?: ReadonlyArray<ProgramType | null | undefined> | null | undefined;
};
export type GwtUserToManyCommentFilter = {
  every?: CommentFilter | null | undefined;
  none?: CommentFilter | null | undefined;
  some?: CommentFilter | null | undefined;
};
export type CommentFilter = {
  adminDashboardFlowComments?: CommentToManyAdminDashboardFlowCommentFilter | null | undefined;
  adminDashboardFlowCommentsExist?: boolean | null | undefined;
  and?: ReadonlyArray<CommentFilter> | null | undefined;
  commentByResponseTo?: CommentFilter | null | undefined;
  commentByResponseToExists?: boolean | null | undefined;
  commentText?: StringFilter | null | undefined;
  commentVieweds?: CommentToManyCommentViewedFilter | null | undefined;
  commentViewedsExist?: boolean | null | undefined;
  commentsByResponseTo?: CommentToManyCommentFilter | null | undefined;
  commentsByResponseToExist?: boolean | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  flowComments?: CommentToManyFlowCommentFilter | null | undefined;
  flowCommentsExist?: boolean | null | undefined;
  gwtUser?: GwtUserFilter | null | undefined;
  gwtUserId?: UUIDFilter | null | undefined;
  not?: CommentFilter | null | undefined;
  or?: ReadonlyArray<CommentFilter> | null | undefined;
  responseTo?: UUIDFilter | null | undefined;
  reviewerDashboardFlowComments?: CommentToManyReviewerDashboardFlowCommentFilter | null | undefined;
  reviewerDashboardFlowCommentsExist?: boolean | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  updatedAt?: DatetimeFilter | null | undefined;
};
export type CommentToManyCommentFilter = {
  every?: CommentFilter | null | undefined;
  none?: CommentFilter | null | undefined;
  some?: CommentFilter | null | undefined;
};
export type CommentToManyFlowCommentFilter = {
  every?: FlowCommentFilter | null | undefined;
  none?: FlowCommentFilter | null | undefined;
  some?: FlowCommentFilter | null | undefined;
};
export type FlowCommentFilter = {
  and?: ReadonlyArray<FlowCommentFilter> | null | undefined;
  comment?: CommentFilter | null | undefined;
  commentId?: UUIDFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  not?: FlowCommentFilter | null | undefined;
  or?: ReadonlyArray<FlowCommentFilter> | null | undefined;
};
export type CommentToManyAdminDashboardFlowCommentFilter = {
  every?: AdminDashboardFlowCommentFilter | null | undefined;
  none?: AdminDashboardFlowCommentFilter | null | undefined;
  some?: AdminDashboardFlowCommentFilter | null | undefined;
};
export type AdminDashboardFlowCommentFilter = {
  and?: ReadonlyArray<AdminDashboardFlowCommentFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  comment?: CommentFilter | null | undefined;
  commentId?: UUIDFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  not?: AdminDashboardFlowCommentFilter | null | undefined;
  or?: ReadonlyArray<AdminDashboardFlowCommentFilter> | null | undefined;
};
export type CommentToManyReviewerDashboardFlowCommentFilter = {
  every?: ReviewerDashboardFlowCommentFilter | null | undefined;
  none?: ReviewerDashboardFlowCommentFilter | null | undefined;
  some?: ReviewerDashboardFlowCommentFilter | null | undefined;
};
export type ReviewerDashboardFlowCommentFilter = {
  and?: ReadonlyArray<ReviewerDashboardFlowCommentFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  comment?: CommentFilter | null | undefined;
  commentId?: UUIDFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  not?: ReviewerDashboardFlowCommentFilter | null | undefined;
  or?: ReadonlyArray<ReviewerDashboardFlowCommentFilter> | null | undefined;
};
export type CommentToManyCommentViewedFilter = {
  every?: CommentViewedFilter | null | undefined;
  none?: CommentViewedFilter | null | undefined;
  some?: CommentViewedFilter | null | undefined;
};
export type CommentViewedFilter = {
  and?: ReadonlyArray<CommentViewedFilter> | null | undefined;
  comment?: CommentFilter | null | undefined;
  commentId?: UUIDFilter | null | undefined;
  gwtUser?: GwtUserFilter | null | undefined;
  gwtUserId?: UUIDFilter | null | undefined;
  not?: CommentViewedFilter | null | undefined;
  or?: ReadonlyArray<CommentViewedFilter> | null | undefined;
};
export type GwtUserToManyActivityFilter = {
  every?: ActivityFilter | null | undefined;
  none?: ActivityFilter | null | undefined;
  some?: ActivityFilter | null | undefined;
};
export type GwtUserToManyNotificationFilter = {
  every?: NotificationFilter | null | undefined;
  none?: NotificationFilter | null | undefined;
  some?: NotificationFilter | null | undefined;
};
export type NotificationFilter = {
  and?: ReadonlyArray<NotificationFilter> | null | undefined;
  data?: JSONFilter | null | undefined;
  gwtUser?: GwtUserFilter | null | undefined;
  gwtUserId?: UUIDFilter | null | undefined;
  name?: StringFilter | null | undefined;
  not?: NotificationFilter | null | undefined;
  or?: ReadonlyArray<NotificationFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
};
export type JSONFilter = {
  equalTo?: any | null | undefined;
  greaterThan?: any | null | undefined;
  greaterThanOrEqualTo?: any | null | undefined;
  in?: ReadonlyArray<any> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: any | null | undefined;
  lessThanOrEqualTo?: any | null | undefined;
  notEqualTo?: any | null | undefined;
  notIn?: ReadonlyArray<any> | null | undefined;
};
export type GwtUserToManyFlowFilter = {
  every?: FlowFilter | null | undefined;
  none?: FlowFilter | null | undefined;
  some?: FlowFilter | null | undefined;
};
export type GwtUserToManyModuleSubmissionFilter = {
  every?: ModuleSubmissionFilter | null | undefined;
  none?: ModuleSubmissionFilter | null | undefined;
  some?: ModuleSubmissionFilter | null | undefined;
};
export type ModuleSubmissionFilter = {
  acceptedBy?: GwtUserFilter | null | undefined;
  acceptedByExists?: boolean | null | undefined;
  acceptedById?: UUIDFilter | null | undefined;
  and?: ReadonlyArray<ModuleSubmissionFilter> | null | undefined;
  attempt?: IntFilter | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  galleryAssetSubmissionId?: UUIDFilter | null | undefined;
  moduleFlow?: ModuleFilter | null | undefined;
  moduleFlowId?: UUIDFilter | null | undefined;
  not?: ModuleSubmissionFilter | null | undefined;
  or?: ReadonlyArray<ModuleSubmissionFilter> | null | undefined;
  submissionStatus?: SubmissionStatusFilter | null | undefined;
};
export type SubmissionStatusFilter = {
  equalTo?: SubmissionStatus | null | undefined;
  greaterThan?: SubmissionStatus | null | undefined;
  greaterThanOrEqualTo?: SubmissionStatus | null | undefined;
  in?: ReadonlyArray<SubmissionStatus> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: SubmissionStatus | null | undefined;
  lessThanOrEqualTo?: SubmissionStatus | null | undefined;
  notEqualTo?: SubmissionStatus | null | undefined;
  notIn?: ReadonlyArray<SubmissionStatus> | null | undefined;
};
export type ModuleFilter = {
  and?: ReadonlyArray<ModuleFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  attempts?: IntFilter | null | undefined;
  autoStartNextModuleFlow?: ModuleFilter | null | undefined;
  autoStartNextModuleFlowExists?: boolean | null | undefined;
  autoStartNextModuleFlowId?: UUIDFilter | null | undefined;
  currentAttempt?: IntFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  galleryAssetComponentsId?: UUIDFilter | null | undefined;
  galleryAssetDeliverableId?: UUIDFilter | null | undefined;
  galleryCollectionSubmissionsId?: UUIDFilter | null | undefined;
  groupModulePreviousModuleFlow?: ModuleFilter | null | undefined;
  groupModulePreviousModuleFlowExists?: boolean | null | undefined;
  groupModulePreviousModuleFlowId?: UUIDFilter | null | undefined;
  isFinalAttempt?: BooleanFilter | null | undefined;
  moduleGroup?: ModuleGroupFilter | null | undefined;
  moduleGroupExists?: boolean | null | undefined;
  moduleGroupId?: UUIDFilter | null | undefined;
  moduleGroupLinksByModuleFlowId?: ModuleToManyModuleGroupLinkFilter | null | undefined;
  moduleGroupLinksByModuleFlowIdExist?: boolean | null | undefined;
  moduleSubmissionsByModuleFlowId?: ModuleToManyModuleSubmissionFilter | null | undefined;
  moduleSubmissionsByModuleFlowIdExist?: boolean | null | undefined;
  modulesByAutoStartNextModuleFlowId?: ModuleToManyModuleFilter | null | undefined;
  modulesByAutoStartNextModuleFlowIdExist?: boolean | null | undefined;
  modulesByGroupModulePreviousModuleFlowId?: ModuleToManyModuleFilter | null | undefined;
  modulesByGroupModulePreviousModuleFlowIdExist?: boolean | null | undefined;
  not?: ModuleFilter | null | undefined;
  or?: ReadonlyArray<ModuleFilter> | null | undefined;
  programType?: ProgramTypeFilter | null | undefined;
  softwareType?: SoftwareTypeFilter | null | undefined;
  submissionLock?: BooleanFilter | null | undefined;
  tasksByModuleFlowId?: ModuleToManyTaskFilter | null | undefined;
  tasksByModuleFlowIdExist?: boolean | null | undefined;
  templateFlow?: TemplateFilter | null | undefined;
  templateFlowExists?: boolean | null | undefined;
  templateFlowId?: UUIDFilter | null | undefined;
  versionNumber?: BigFloatFilter | null | undefined;
};
export type SoftwareTypeFilter = {
  equalTo?: SoftwareType | null | undefined;
  greaterThan?: SoftwareType | null | undefined;
  greaterThanOrEqualTo?: SoftwareType | null | undefined;
  in?: ReadonlyArray<SoftwareType> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: SoftwareType | null | undefined;
  lessThanOrEqualTo?: SoftwareType | null | undefined;
  notEqualTo?: SoftwareType | null | undefined;
  notIn?: ReadonlyArray<SoftwareType> | null | undefined;
};
export type ProgramTypeFilter = {
  equalTo?: ProgramType | null | undefined;
  greaterThan?: ProgramType | null | undefined;
  greaterThanOrEqualTo?: ProgramType | null | undefined;
  in?: ReadonlyArray<ProgramType> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: ProgramType | null | undefined;
  lessThanOrEqualTo?: ProgramType | null | undefined;
  notEqualTo?: ProgramType | null | undefined;
  notIn?: ReadonlyArray<ProgramType> | null | undefined;
};
export type BigFloatFilter = {
  equalTo?: BigFloat | null | undefined;
  greaterThan?: BigFloat | null | undefined;
  greaterThanOrEqualTo?: BigFloat | null | undefined;
  in?: ReadonlyArray<BigFloat> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: BigFloat | null | undefined;
  lessThanOrEqualTo?: BigFloat | null | undefined;
  notEqualTo?: BigFloat | null | undefined;
  notIn?: ReadonlyArray<BigFloat> | null | undefined;
};
export type ModuleToManyModuleFilter = {
  every?: ModuleFilter | null | undefined;
  none?: ModuleFilter | null | undefined;
  some?: ModuleFilter | null | undefined;
};
export type ModuleToManyTaskFilter = {
  every?: TaskFilter | null | undefined;
  none?: TaskFilter | null | undefined;
  some?: TaskFilter | null | undefined;
};
export type TaskFilter = {
  and?: ReadonlyArray<TaskFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  complete?: BooleanFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  moduleFlow?: ModuleFilter | null | undefined;
  moduleFlowExists?: boolean | null | undefined;
  moduleFlowId?: UUIDFilter | null | undefined;
  not?: TaskFilter | null | undefined;
  or?: ReadonlyArray<TaskFilter> | null | undefined;
  priority?: IntFilter | null | undefined;
  templateFlow?: TemplateFilter | null | undefined;
  templateFlowExists?: boolean | null | undefined;
  templateFlowId?: UUIDFilter | null | undefined;
};
export type TemplateFilter = {
  and?: ReadonlyArray<TemplateFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  modulesByTemplateFlowId?: TemplateToManyModuleFilter | null | undefined;
  modulesByTemplateFlowIdExist?: boolean | null | undefined;
  not?: TemplateFilter | null | undefined;
  or?: ReadonlyArray<TemplateFilter> | null | undefined;
  tasksByTemplateFlowId?: TemplateToManyTaskFilter | null | undefined;
  tasksByTemplateFlowIdExist?: boolean | null | undefined;
};
export type TemplateToManyModuleFilter = {
  every?: ModuleFilter | null | undefined;
  none?: ModuleFilter | null | undefined;
  some?: ModuleFilter | null | undefined;
};
export type TemplateToManyTaskFilter = {
  every?: TaskFilter | null | undefined;
  none?: TaskFilter | null | undefined;
  some?: TaskFilter | null | undefined;
};
export type ModuleToManyModuleSubmissionFilter = {
  every?: ModuleSubmissionFilter | null | undefined;
  none?: ModuleSubmissionFilter | null | undefined;
  some?: ModuleSubmissionFilter | null | undefined;
};
export type ModuleToManyModuleGroupLinkFilter = {
  every?: ModuleGroupLinkFilter | null | undefined;
  none?: ModuleGroupLinkFilter | null | undefined;
  some?: ModuleGroupLinkFilter | null | undefined;
};
export type ModuleGroupLinkFilter = {
  and?: ReadonlyArray<ModuleGroupLinkFilter> | null | undefined;
  groupIndex?: IntFilter | null | undefined;
  moduleFlow?: ModuleFilter | null | undefined;
  moduleFlowId?: UUIDFilter | null | undefined;
  moduleGroupFlow?: ModuleGroupFilter | null | undefined;
  moduleGroupFlowId?: UUIDFilter | null | undefined;
  not?: ModuleGroupLinkFilter | null | undefined;
  or?: ReadonlyArray<ModuleGroupLinkFilter> | null | undefined;
};
export type ModuleGroupFilter = {
  and?: ReadonlyArray<ModuleGroupFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  moduleGroupLinksByModuleGroupFlowId?: ModuleGroupToManyModuleGroupLinkFilter | null | undefined;
  moduleGroupLinksByModuleGroupFlowIdExist?: boolean | null | undefined;
  modules?: ModuleGroupToManyModuleFilter | null | undefined;
  modulesExist?: boolean | null | undefined;
  not?: ModuleGroupFilter | null | undefined;
  or?: ReadonlyArray<ModuleGroupFilter> | null | undefined;
  programTypes?: ProgramTypeListFilter | null | undefined;
  shuffle?: BooleanFilter | null | undefined;
  softwareTypes?: SoftwareTypeListFilter | null | undefined;
  versionNumber?: BigFloatFilter | null | undefined;
};
export type SoftwareTypeListFilter = {
  equalTo?: ReadonlyArray<SoftwareType | null | undefined> | null | undefined;
  greaterThan?: ReadonlyArray<SoftwareType | null | undefined> | null | undefined;
  greaterThanOrEqualTo?: ReadonlyArray<SoftwareType | null | undefined> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: ReadonlyArray<SoftwareType | null | undefined> | null | undefined;
  lessThanOrEqualTo?: ReadonlyArray<SoftwareType | null | undefined> | null | undefined;
  notEqualTo?: ReadonlyArray<SoftwareType | null | undefined> | null | undefined;
};
export type ModuleGroupToManyModuleFilter = {
  every?: ModuleFilter | null | undefined;
  none?: ModuleFilter | null | undefined;
  some?: ModuleFilter | null | undefined;
};
export type ModuleGroupToManyModuleGroupLinkFilter = {
  every?: ModuleGroupLinkFilter | null | undefined;
  none?: ModuleGroupLinkFilter | null | undefined;
  some?: ModuleGroupLinkFilter | null | undefined;
};
export type GwtUserToManyFlowReviewerFilter = {
  every?: FlowReviewerFilter | null | undefined;
  none?: FlowReviewerFilter | null | undefined;
  some?: FlowReviewerFilter | null | undefined;
};
export type FlowReviewerFilter = {
  and?: ReadonlyArray<FlowReviewerFilter> | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  not?: FlowReviewerFilter | null | undefined;
  or?: ReadonlyArray<FlowReviewerFilter> | null | undefined;
  reviewer?: GwtUserFilter | null | undefined;
  reviewerId?: UUIDFilter | null | undefined;
};
export type GwtUserToManyFlowFavoriteFilter = {
  every?: FlowFavoriteFilter | null | undefined;
  none?: FlowFavoriteFilter | null | undefined;
  some?: FlowFavoriteFilter | null | undefined;
};
export type FlowFavoriteFilter = {
  and?: ReadonlyArray<FlowFavoriteFilter> | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  flow?: FlowFilter | null | undefined;
  flowId?: UUIDFilter | null | undefined;
  gwtUser?: GwtUserFilter | null | undefined;
  gwtUserId?: UUIDFilter | null | undefined;
  not?: FlowFavoriteFilter | null | undefined;
  or?: ReadonlyArray<FlowFavoriteFilter> | null | undefined;
};
export type GwtUserToManyCommentViewedFilter = {
  every?: CommentViewedFilter | null | undefined;
  none?: CommentViewedFilter | null | undefined;
  some?: CommentViewedFilter | null | undefined;
};
export type GwtUserToManyCompanyFilter = {
  every?: CompanyFilter | null | undefined;
  none?: CompanyFilter | null | undefined;
  some?: CompanyFilter | null | undefined;
};
export type CompanyFilter = {
  and?: ReadonlyArray<CompanyFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  description?: StringFilter | null | undefined;
  gwtUsers?: CompanyToManyGwtUserFilter | null | undefined;
  gwtUsersExist?: boolean | null | undefined;
  name?: StringFilter | null | undefined;
  not?: CompanyFilter | null | undefined;
  numberOfCertifications?: IntFilter | null | undefined;
  numberOfUsers?: IntFilter | null | undefined;
  or?: ReadonlyArray<CompanyFilter> | null | undefined;
  owner?: GwtUserFilter | null | undefined;
  ownerId?: UUIDFilter | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  updatedAt?: DatetimeFilter | null | undefined;
};
export type CompanyToManyGwtUserFilter = {
  every?: GwtUserFilter | null | undefined;
  none?: GwtUserFilter | null | undefined;
  some?: GwtUserFilter | null | undefined;
};
export type GwtUserToManyPolFileUploadFilter = {
  every?: PolFileUploadFilter | null | undefined;
  none?: PolFileUploadFilter | null | undefined;
  some?: PolFileUploadFilter | null | undefined;
};
export type PolFileUploadFilter = {
  and?: ReadonlyArray<PolFileUploadFilter> | null | undefined;
  fileName?: StringFilter | null | undefined;
  fileSize?: BigIntFilter | null | undefined;
  galleryAssetId?: UUIDFilter | null | undefined;
  gwtUser?: GwtUserFilter | null | undefined;
  gwtUserId?: UUIDFilter | null | undefined;
  not?: PolFileUploadFilter | null | undefined;
  or?: ReadonlyArray<PolFileUploadFilter> | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  tossKey?: StringFilter | null | undefined;
  tossUrl?: StringFilter | null | undefined;
  uploadError?: StringFilter | null | undefined;
  uploadStatus?: PolFileUploadStatusFilter | null | undefined;
};
export type BigIntFilter = {
  equalTo?: BigInt | null | undefined;
  greaterThan?: BigInt | null | undefined;
  greaterThanOrEqualTo?: BigInt | null | undefined;
  in?: ReadonlyArray<BigInt> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: BigInt | null | undefined;
  lessThanOrEqualTo?: BigInt | null | undefined;
  notEqualTo?: BigInt | null | undefined;
  notIn?: ReadonlyArray<BigInt> | null | undefined;
};
export type PolFileUploadStatusFilter = {
  equalTo?: PolFileUploadStatus | null | undefined;
  greaterThan?: PolFileUploadStatus | null | undefined;
  greaterThanOrEqualTo?: PolFileUploadStatus | null | undefined;
  in?: ReadonlyArray<PolFileUploadStatus> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: PolFileUploadStatus | null | undefined;
  lessThanOrEqualTo?: PolFileUploadStatus | null | undefined;
  notEqualTo?: PolFileUploadStatus | null | undefined;
  notIn?: ReadonlyArray<PolFileUploadStatus> | null | undefined;
};
export type GwtUserToManyFeedbackFilter = {
  every?: FeedbackFilter | null | undefined;
  none?: FeedbackFilter | null | undefined;
  some?: FeedbackFilter | null | undefined;
};
export type FeedbackFilter = {
  and?: ReadonlyArray<FeedbackFilter> | null | undefined;
  archivedAt?: DatetimeFilter | null | undefined;
  claimedBy?: GwtUserFilter | null | undefined;
  claimedByExists?: boolean | null | undefined;
  claimedById?: UUIDFilter | null | undefined;
  createdAt?: DatetimeFilter | null | undefined;
  feedback?: StringFilter | null | undefined;
  feedbackLevel?: FeedbackLevelFilter | null | undefined;
  gwtUser?: GwtUserFilter | null | undefined;
  gwtUserId?: UUIDFilter | null | undefined;
  not?: FeedbackFilter | null | undefined;
  or?: ReadonlyArray<FeedbackFilter> | null | undefined;
  resolved?: BooleanFilter | null | undefined;
  rowId?: UUIDFilter | null | undefined;
  updatedAt?: DatetimeFilter | null | undefined;
};
export type FeedbackLevelFilter = {
  equalTo?: FeedbackLevel | null | undefined;
  greaterThan?: FeedbackLevel | null | undefined;
  greaterThanOrEqualTo?: FeedbackLevel | null | undefined;
  in?: ReadonlyArray<FeedbackLevel> | null | undefined;
  isNull?: boolean | null | undefined;
  lessThan?: FeedbackLevel | null | undefined;
  lessThanOrEqualTo?: FeedbackLevel | null | undefined;
  notEqualTo?: FeedbackLevel | null | undefined;
  notIn?: ReadonlyArray<FeedbackLevel> | null | undefined;
};
export type FlowToManyFlowReviewerFilter = {
  every?: FlowReviewerFilter | null | undefined;
  none?: FlowReviewerFilter | null | undefined;
  some?: FlowReviewerFilter | null | undefined;
};
export type FlowToManyFlowCommentFilter = {
  every?: FlowCommentFilter | null | undefined;
  none?: FlowCommentFilter | null | undefined;
  some?: FlowCommentFilter | null | undefined;
};
export type FlowToManyAdminDashboardFlowCommentFilter = {
  every?: AdminDashboardFlowCommentFilter | null | undefined;
  none?: AdminDashboardFlowCommentFilter | null | undefined;
  some?: AdminDashboardFlowCommentFilter | null | undefined;
};
export type FlowToManyReviewerDashboardFlowCommentFilter = {
  every?: ReviewerDashboardFlowCommentFilter | null | undefined;
  none?: ReviewerDashboardFlowCommentFilter | null | undefined;
  some?: ReviewerDashboardFlowCommentFilter | null | undefined;
};
export type FlowToManyFlowFavoriteFilter = {
  every?: FlowFavoriteFilter | null | undefined;
  none?: FlowFavoriteFilter | null | undefined;
  some?: FlowFavoriteFilter | null | undefined;
};
export type ReviewerTemplateCardTemplateFlowsPaginationQuery$variables = {
  count?: number | null | undefined;
  cursor?: any | null | undefined;
  flowFilter?: FlowFilter | null | undefined;
  gwtUserId?: UUID | null | undefined;
};
export type ReviewerTemplateCardTemplateFlowsPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ReviewerTemplateCardPaginationFragment_templateFlows">;
};
export type ReviewerTemplateCardTemplateFlowsPaginationQuery = {
  response: ReviewerTemplateCardTemplateFlowsPaginationQuery$data;
  variables: ReviewerTemplateCardTemplateFlowsPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "flowFilter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "gwtUserId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "gwtUserId",
  "variableName": "gwtUserId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "flowFilter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "CREATED_AT_DESC"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  },
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationSeconds",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flowId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v1/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "condition"
    }
  ],
  "concreteType": "FlowFavoritesConnection",
  "kind": "LinkedField",
  "name": "flowFavorites",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FlowFavorite",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v9/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionNumber",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReviewerTemplateCardTemplateFlowsPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          {
            "kind": "Variable",
            "name": "flowFilter",
            "variableName": "flowFilter"
          },
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "ReviewerTemplateCardPaginationFragment_templateFlows"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReviewerTemplateCardTemplateFlowsPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "FlowsConnection",
        "kind": "LinkedField",
        "name": "flows",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FlowsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Flow",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "durationInSeconds",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkedType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GwtUser",
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GwtUser",
                    "kind": "LinkedField",
                    "name": "lastModifiedBy",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Module",
                    "kind": "LinkedField",
                    "name": "module",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Flow",
                        "kind": "LinkedField",
                        "name": "flow",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dueAt",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1
                              }
                            ],
                            "concreteType": "FlowReviewersConnection",
                            "kind": "LinkedField",
                            "name": "flowReviewers",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowReviewer",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GwtUser",
                                    "kind": "LinkedField",
                                    "name": "reviewer",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "firstName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "lastName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Company",
                                        "kind": "LinkedField",
                                        "name": "company",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          (v6/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v3/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "flowReviewers(first:1)"
                          },
                          (v6/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attempts",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      (v11/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ModuleGroup",
                    "kind": "LinkedField",
                    "name": "moduleGroup",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ModuleGroupLinksConnection",
                        "kind": "LinkedField",
                        "name": "moduleGroupLinksByModuleGroupFlowId",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ModuleGroupLink",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Module",
                                "kind": "LinkedField",
                                "name": "moduleFlow",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Flow",
                                    "kind": "LinkedField",
                                    "name": "flow",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FlowReviewersConnection",
                                        "kind": "LinkedField",
                                        "name": "flowReviewers",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FlowReviewer",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "GwtUser",
                                                "kind": "LinkedField",
                                                "name": "reviewer",
                                                "plural": false,
                                                "selections": (v7/*: any*/),
                                                "storageKey": null
                                              },
                                              (v6/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v6/*: any*/),
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Flow",
                        "kind": "LinkedField",
                        "name": "flow",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v3/*: any*/),
                          (v6/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": [
          "filter",
          "orderBy"
        ],
        "handle": "connection",
        "key": "ReviewerTemplateCard_flows",
        "kind": "LinkedHandle",
        "name": "flows"
      }
    ]
  },
  "params": {
    "cacheID": "e4c474efa1b8309d4bf131f9011a6348",
    "id": null,
    "metadata": {},
    "name": "ReviewerTemplateCardTemplateFlowsPaginationQuery",
    "operationKind": "query",
    "text": "query ReviewerTemplateCardTemplateFlowsPaginationQuery(\n  $count: Int\n  $cursor: Cursor\n  $flowFilter: FlowFilter\n  $gwtUserId: UUID\n) {\n  ...ReviewerTemplateCardPaginationFragment_templateFlows_3SI2rV\n}\n\nfragment AssignGroupTemplate on ModuleGroup {\n  moduleGroupLinksByModuleGroupFlowId {\n    nodes {\n      moduleFlow {\n        flow {\n          name\n          durationSeconds\n          flowReviewers {\n            nodes {\n              reviewer {\n                fullName\n                id\n              }\n              id\n            }\n          }\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n  flow {\n    name\n    rowId\n    id\n  }\n}\n\nfragment AssignTemplateCardPopupModuleFragment on Module {\n  flow {\n    name\n    rowId\n    dueAt\n    createdAt\n    durationSeconds\n    flowReviewers(first: 1) {\n      nodes {\n        reviewer {\n          firstName\n          lastName\n          company {\n            name\n            id\n          }\n          rowId\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n  attempts\n}\n\nfragment GroupTemplateOptions_moduleGroup_1AeAhh on ModuleGroup {\n  ...AssignGroupTemplate\n  flow {\n    rowId\n    name\n    ...TemplatesFavorite_flow_1AeAhh\n    id\n  }\n}\n\nfragment ReviewerTemplateCardPaginationFragment_templateFlows_3SI2rV on Query {\n  flows(first: $count, after: $cursor, filter: $flowFilter, orderBy: CREATED_AT_DESC) {\n    edges {\n      node {\n        rowId\n        ...TemplateFavorite_flow_1AeAhh\n        id\n        __typename\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TemplateFavorite_flow_1AeAhh on Flow {\n  name\n  rowId\n  createdAt\n  durationInSeconds\n  updatedAt\n  linkedType\n  owner {\n    fullName\n    id\n  }\n  lastModifiedBy {\n    fullName\n    id\n  }\n  module {\n    ...TemplateOptions_module_1AeAhh\n    flowId\n    attempts\n    versionNumber\n    id\n  }\n  moduleGroup {\n    versionNumber\n    ...GroupTemplateOptions_moduleGroup_1AeAhh\n    moduleGroupLinksByModuleGroupFlowId {\n      nodes {\n        moduleFlow {\n          flow {\n            rowId\n            name\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment TemplateOptions_module_1AeAhh on Module {\n  ...AssignTemplateCardPopupModuleFragment\n  flow {\n    rowId\n    name\n    ...TemplatesFavorite_flow_1AeAhh\n    id\n  }\n}\n\nfragment TemplatesFavorite_flow_1AeAhh on Flow {\n  rowId\n  flowFavorites(condition: {gwtUserId: $gwtUserId}) {\n    nodes {\n      flowId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "de3909dfb3b3f7c2d2f600089b236df6";

export default node;
